function prefillItemQuestion() {
  const context = document.querySelector('[data-regear-item-question]');
  const field = document.querySelector('main form[action*="/contact"] textarea[name="contact[body]"]');
  if (!context || !field || field.value.trim()) return;
  const params = new URLSearchParams(location.search);
  const item = (params.get('item') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 250);
  const variant = (params.get('variant') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 150);
  let product;
  try { product = new URL(params.get('product') || '', location.origin); } catch { return; }
  if (!item || product.origin !== location.origin || !/^\/products\/[a-z0-9-]+\/?$/.test(product.pathname)) return;
  product.search = '';
  product.hash = '';
  const variantId = params.get('variant_id');
  if (/^\d{1,20}$/.test(variantId || '')) product.searchParams.set('variant', variantId);
  field.value = [item, variant && variant !== 'Default Title' ? variant : '', product.href, context.dataset.questionLabel].filter(Boolean).join('\n') + '\n';
  context.querySelector('[data-regear-question-context]').textContent = [item, variant, product.href].filter(Boolean).join(' — ');
  context.hidden = false;
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefillItemQuestion, { once: true });
else prefillItemQuestion();
document.addEventListener('shopify:section:load', prefillItemQuestion);
